import React from 'react'

import {Route} from 'react-router-dom'
import Login from '$src/login/components/Login'

export default [<Route key="login1" path="/login" component={Login} />]



// WEBPACK FOOTER //
// ./src/login/routes.js